import React from 'react'
import { ImageCrop, imageCropStyles } from './imageCrop'
import Anchor from '../anchor'

export interface ArticleCardData {
  id: number
  title: string
  slug: string
  featureImage?: string
  featureImageCrop?: ImageCrop | null
  excerpt?: string
  showExcerpt?: boolean
  author?: string
  publishedAt?: string
  category?: { name: string; slug: string } | null
  subcategory?: { name: string; slug: string } | null
}

export const articleLabel = (article: ArticleCardData): string =>
  article.subcategory?.name || article.category?.name || ''

// The handoff's story-card component (index.html / category-fashion.html).
// Renders inside a .story-grid within the .cullector-hub scope.
const ArticleCard: React.FC<{ article: ArticleCardData }> = ({ article }) => {
  const label = articleLabel(article)
  const href = `/cullector/${article.slug}`
  return (
    <article className="story-card">
      <Anchor
        className="story-thumb"
        href={href}
        tabIndex={-1}
        aria-hidden="true"
      >
        {article.featureImage && (
          <img
            src={article.featureImage}
            alt=""
            loading="lazy"
            style={imageCropStyles(article.featureImageCrop)}
          />
        )}
      </Anchor>
      {label && <span className="t-eyebrow eyebrow-sm">{label}</span>}
      <h3 className="t-h2">
        <Anchor href={href}>{article.title}</Anchor>
      </h3>
      {article.showExcerpt && article.excerpt && (
        <p className="story-dek t-body">{article.excerpt}</p>
      )}
      {article.author && (
        <div className="story-footer">
          <span className="story-byline">{article.author}</span>
        </div>
      )}
    </article>
  )
}

export default ArticleCard
